module.exports = __webpack_public_path__ + "img/x5s_mount.db124aa5.png";